import { cfpBaseUrl } from '../../network/urls';

/**
 * Same API CP52 dialog uses:
 * POST mrc/getCP52
 * Body: { applicationId, oracleTrackingId, isPostedToIPS }
 */
export const fetchApprovedMrcBill = async (
    { applicationId, oracleTrackingId = '', isPostedToIPS = false } = {},
    token
) => {
    if (!applicationId) {
        throw new Error('Application ID is required to load MRC bill.');
    }
    if (!String(oracleTrackingId || '').trim()) {
        throw new Error('Oracle Tracking ID is required to load MRC bill.');
    }

    const myHeaders = new Headers();
    myHeaders.append('Authorization', token);
    myHeaders.append('Content-Type', 'application/json');

    const raw = JSON.stringify({
        applicationId: String(applicationId).trim(),
        oracleTrackingId: String(oracleTrackingId).trim(),
        isPostedToIPS: Boolean(isPostedToIPS),
    });

    const response = await fetch(`${cfpBaseUrl}mrc/getCP52`, {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
    });

    let result;
    try {
        result = await response.json();
    } catch (e) {
        throw new Error('Invalid response from mrc/getCP52.');
    }

    if (result.status !== '200' && result.status !== 200) {
        throw new Error(
            result.message ||
                result.error ||
                'No record found for the specified tracking ID.'
        );
    }

    const rows = Array.isArray(result.data)
        ? result.data
        : result.data
          ? [result.data]
          : [];

    if (!rows.length) {
        throw new Error(
            result.message ||
                result.error ||
                'No record found for the specified tracking ID.'
        );
    }

    return result;
};
